/**
 * Given a list of one or more URL segments (possibly containing one or more absolute segments starting
 * with a protocol) ensures that a final valid URL is produced where relative paths are concatenated,
 * and in the case of multiple absolute paths, that the last occurrence overrides all other
 * occurrences.
 */
var joinUrlSegments = function (segments, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.addTrailingSlash, addTrailingSlash = _d === void 0 ? false : _d;
    var url = '';
    for (var i = 0; i < segments.length; i++) {
        var shouldAddTrailingSlashToSegment = i < segments.length - 1 || addTrailingSlash;
        var nextSegment = (_b = segments[i + 1]) !== null && _b !== void 0 ? _b : '';
        var segment = segments[i];
        // Ignore empty segments
        if (segment === '')
            continue;
        // Force trailing slash
        if (!segment.match(/\/$/) && shouldAddTrailingSlashToSegment && !nextSegment.match(/^\//))
            segment += '/';
        if (segment.match(/^http/)) {
            // Absolute segments override any previous segments (absolute or relative)
            url = segment;
        }
        else {
            // Relative segments are concatenated on
            url += segment;
        }
    }
    return url;
};
export { joinUrlSegments };
//# sourceMappingURL=joinUrlSegments.js.map